__turbopack_context__.v({
  "container": "SzqZGa_container",
  "error-message": "SzqZGa_error-message",
  "header": "SzqZGa_header",
  "header__country-selector": "SzqZGa_header__country-selector",
  "header__dropdown-skeleton": "SzqZGa_header__dropdown-skeleton",
  "header__year-selector": "SzqZGa_header__year-selector",
  "note-wrapper": "SzqZGa_note-wrapper",
  "production-table": "SzqZGa_production-table",
  "production-table--sticky": "SzqZGa_production-table--sticky",
  "requirements-wrapper": "SzqZGa_requirements-wrapper",
});
